import { FloatingPanelMenuItemRenderer } from "../types/FloatingPanelMenuItemRenderer";
import "./styles/text-menu-item.css";

export const TextMenuItem: FloatingPanelMenuItemRenderer = (model, item, itemIndex, menuId, onClick) => {
    const key = `${menuId}-${itemIndex}`;

    return (
        <li
            className="cui-text-menu-item"
            key={key}
            role="menuitem"
            id={key}
            data-hook={item.dataHook !== undefined ? item.dataHook : "text-button-menu-option"}
            aria-label={item.ariaLabel}
            aria-selected={model.activeItemIndex === itemIndex}
            onClick={(e) => {
                onClick(e, itemIndex);
                item.onSelect();
            }}>
            <span className="cui-text-menu-item__label">{item.text}</span>
        </li>
    );
};
